const Sticky = require('sticky-js')

export class StickyFunc {
  constructor() {
    var sticky = new Sticky('.js-sticky')
  }
}
